<template>
  <div>
    <el-row>
      <div class="model-header">
        <h2>Xem danh mục sản phẩm: {{ modelData.name }}</h2>
        <el-button @click="backModel" size="small" class="btn-back">Trờ về</el-button>
      </div>
    </el-row>
    <el-row>
      <div class="model-content">
        <el-col :span="12">
          <el-form label-position="right" :model="modelData" ref="createModel" label-width="135px" @submit.native.prevent>
            <el-form-item label="Tên danh mục:" class="form-item">
              <span>{{ modelData.name }}</span>
            </el-form-item>
            <el-form-item label="Nhóm menu:" class="form-item">
              <span>{{ modelData.type_txt }}</span>
            </el-form-item>
            <el-form-item label="Kích hoạt:">
              <el-switch
                active-color="#13ce66"
                inactive-color="#7f8c8d"
                disabled
                v-model="modelData.status">
              </el-switch>
            </el-form-item>
          </el-form>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
export default {
  name: 'CategoryBlogShow',
  data () {
    return {
      canSubmit: true,
      modelData: {
        name: '',
        parant_id: '',
        status: false
      },
      listCategories: []
    }
  },
  mounted () {
    this.configBreadcrumb()
    this.fetchModel()
  },
  methods: {
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'category-blogs-index', text: 'Danh mục tin tức' },
        { name: 'category-blogs-update', text: 'Xem danh mục' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'category-blogs-index'})
    },
    // Tải dữ liệu Model xuống
    fetchModel () {
      this.canSubmit = false
      axios.get('category-blogs/' + this.$route.params.id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.modelData = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/category-blogs/Show.vue